// 意大利语
import it from '../JsonLang/it.json'
import enSpec from '../JsonLangSpec/en.json'
export const lang = {
  ...it, ...enSpec
}